export const setupLazyLoadImages = (emblaApi) => {
  const imagesLoaded = []
  const slideNodes = emblaApi.slideNodes()
  const imageNodes = slideNodes.map((slideNode) => {
    const image = slideNode.querySelector('img')
    return image || null
  })

  const loadImageInView = (index) => {
    const imageNode = imageNodes[index]
    const slideNode = slideNodes[index]
    
    if (!imageNode) return
    
    const src = imageNode.getAttribute('data-src')
    if (src) {
      imageNode.src = src
      imageNode.removeAttribute('data-src')
      
      const onLoad = () => {
        slideNode.classList.add('embla__lazy-load--has-loaded')
        imageNode.removeEventListener('load', onLoad)
      }
      imageNode.addEventListener('load', onLoad)
    }
    
    imagesLoaded.push(index)
  }

  const loadImagesInView = () => {
    emblaApi
      .slidesInView()
      .filter((index) => !imagesLoaded.includes(index))
      .forEach(loadImageInView)
    return imagesLoaded.length === imageNodes.length
  }

  const loadImagesInViewAndDestroyIfDone = (emblaApi, eventName) => {
    const loadedAll = loadImagesInView()
    if (loadedAll) emblaApi.off(eventName, loadImagesInViewAndDestroyIfDone)
  }

  return loadImagesInViewAndDestroyIfDone
}

export const setupLazyLoadVideos = (emblaApi) => {
  const videosLoaded = []
  const slideNodes = emblaApi.slideNodes()
  const videoNodes = slideNodes.map((slideNode) => {
    const video = slideNode.querySelector('video')
    return video || null
  })

  const loadVideoInView = (index) => {
    const videoNode = videoNodes[index]
    const slideNode = slideNodes[index]
    
    if (!videoNode) return
    
    const sourceNode = videoNode.querySelector('source')
    if (sourceNode) {
      const src = sourceNode.getAttribute('data-src')
      if (src) {
        sourceNode.src = src
        sourceNode.removeAttribute('data-src')
        videoNode.load()
        
        const onLoadedData = () => {
          slideNode.classList.add('embla__lazy-load--has-loaded')
          videoNode.removeEventListener('loadeddata', onLoadedData)
        }
        videoNode.addEventListener('loadeddata', onLoadedData)
      }
    }
    
    videosLoaded.push(index)
  }

  const loadVideosInView = () => {
    emblaApi
      .slidesInView()
      .filter((index) => !videosLoaded.includes(index))
      .forEach(loadVideoInView)
    return videosLoaded.length === videoNodes.length
  }

  const loadVideosInViewAndDestroyIfDone = (emblaApi, eventName) => {
    const loadedAll = loadVideosInView()
    if (loadedAll) emblaApi.off(eventName, loadVideosInViewAndDestroyIfDone)
  }

  return loadVideosInViewAndDestroyIfDone
}

export const setupVideoPlayback = (emblaApi) => {
  const videoNodes = emblaApi.slideNodes().map((slideNode) => {
    const video = slideNode.querySelector('video')
    return video || null
  })

  const handleVideoPlayback = () => {
    const selectedIndex = emblaApi.selectedScrollSnap()
    
    videoNodes.forEach((videoNode, index) => {
      if (!videoNode) return
      
      const sourceNode = videoNode.querySelector('source')
      // Only interact with videos that have been loaded (no data-src)
      if (!sourceNode || !sourceNode.src || sourceNode.getAttribute('data-src')) return
      
      if (index === selectedIndex) {
        // Play video in active slide
        const playPromise = videoNode.play()
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Video play prevented:', error)
          })
        }
      } else {
        // Pause videos in other slides
        videoNode.pause()
      }
    })
  }

  return handleVideoPlayback
}